// Ordre des employés = ordre des lignes du dernier planning Excel chargé.
// Utilisé partout (planning, accueil, liste des employés) pour retrouver le tableau du magasin.
import { useEffect, useState } from 'react'
import api from './api'

export function useExcelOrder(establishmentId?: string | null): string[] {
  const [order, setOrder] = useState<string[]>([])
  useEffect(() => {
    if (!establishmentId) { setOrder([]); return }
    api.get(`/planning-import/last?establishmentId=${establishmentId}`)
      .then(r => setOrder(Array.isArray(r.data?.employeeOrder) ? r.data.employeeOrder : []))
      .catch(() => setOrder([]))
  }, [establishmentId])
  return order
}

/** Trie selon l'ordre de l'Excel ; ceux qui n'y sont pas passent après, par prénom */
export function sortByExcelOrder<T extends { id: string; firstName?: string }>(list: T[], order: string[]): T[] {
  if (!order.length) return list
  const rank = (id: string) => { const i = order.indexOf(id); return i === -1 ? Number.MAX_SAFE_INTEGER : i }
  return [...list].sort((a, b) => rank(a.id) - rank(b.id) || (a.firstName || '').localeCompare(b.firstName || ''))
}
